import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from 'antd';
import UIComponent from './uiComponent';
function UIDividerComponent(props) {
    return (_jsxs(_Fragment, { children: [props.type === 'primary' && (_jsx(Typography.Title, { level: 3, style: {
                    marginTop: '0px',
                    ...props.styling,
                }, children: props.title })), props.type === 'secondary' && (_jsx(Typography.Title, { level: 4, style: { color: '#000000', textDecoration: 'underline', padding: '10px 0', ...props.styling }, children: props.title }))] }));
}
export default class UIDivider extends UIComponent {
    title;
    type;
    style;
    constructor(s) {
        super(s);
        this.title = this.getProperty('title');
        this.style = this.getProperty('style', '');
        const type = this.getProperty('type');
        if (!(type === 'primary' || type === 'secondary')) {
            throw new Error(`The divider ${this.name} type property should be primary or secondary.`);
        }
        this.type = type;
    }
    getComponent() {
        const props = {
            title: this.title,
            type: this.type,
            styling: this.style,
        };
        return _jsx(UIDividerComponent, { ...props });
    }
}
//# sourceMappingURL=uiDivider.js.map